
import { Step, Track, TimelineStep, Testimonial } from './types';

export const STEPS: Step[] = [
  {
    id: 1,
    phase: 'المرحلة الأولى',
    title: 'هندسة الأساس',
    description: 'تفكيك وإعادة بناء فهمك للتصميم. نركز هنا على القواعد الأكاديمية وسيكولوجية المستخدم.',
    longDescription: 'الآن في كثير دورات تقدم التصميم عن طريق كانفا ولكن مشكلتها، اما <span class="font-black text-primary underline decoration-primary/30">قديمة</span>؟ او فقط تعلمك <span class="font-black text-gray-900 dark:text-white">الادوات</span> في كانفا، وهذه تحدي كبير، انت تحتاج مو بس تعرف الادوات، كمان تعرف <span class="font-black text-primary">كيف تستخدمها</span> في تصميمك ومتى تسخدم الاداة او التطبيق الموجود في كانفا بالشكل الصحيح.',
    icon: 'architecture',
    iconColor: 'text-primary'
  },
  {
    id: 2,
    phase: 'المرحلة الثانية',
    title: 'محاكاة السوق',
    description: 'وداعاً للمشاريع الوهمية. ستعمل على مشاريع تحاكي طلبات السوق الحالية والعملاء.',
    longDescription: 'بعد ما تتعلم كيف تصمم وكيف تسوي منشورات اعلانية وعروض تقديمية، الآن دورنا امشي معك <span class="font-black text-blue-500">خطوة بخطوة</span>، كيف <span class="font-black text-gray-900 dark:text-white">تسوق لنفسك</span> كمصمم؟ كيف تحصل على <span class="font-black text-blue-500">عملاء</span>؟ وكيف تعمل لنفسك <span class="font-black text-gray-900 dark:text-white">ملف اعمال احترافي</span>، خطوة بخطوة همشي معك باذن الله لتبني سمعتك في السوق.',
    icon: 'science',
    iconColor: 'text-blue-500'
  },
  {
    id: 3,
    phase: 'المرحلة الثالثة',
    title: 'نظام الدخل',
    description: 'كيف تحول المهارة إلى مال. استراتيجيات التسعير والتفاوض وبناء الولاء.',
    longDescription: '<span class="font-black text-green-600">المرحلة الثالثة</span> لتحقيق اكبر فائدة وكيف تتعامل مع العميل، كيف <span class="font-black text-gray-900 dark:text-white">تسعر خدماتك</span>؟ كيف تحط سعر ما يظلمك كمصمم؟ وكيف ايضًا تخلي العميل نفسه يسوق لك <span class="font-black text-green-600">"تسويق شبكي"</span> وكثير من التفاصيل هنا مركزة على <span class="font-black text-gray-900 dark:text-white">التعامل مع العميل</span>، كل هذه الخبرة اكتسبتها خلال <span class="font-black text-green-600">سنوات طويلة</span> في العمل.',
    icon: 'monetization_on',
    iconColor: 'text-green-500'
  }
];

export const TOOLS = [
  {
    name: 'موقع كانفا',
    description: 'سوف نستخدمه في التصميم',
    icon: 'palette',
    color: 'from-blue-400 to-indigo-600',
    extra: ''
  },
  {
    name: 'موقع Image FX',
    description: 'سوف نستخدمه في توليد العناصر باستخدام الذكاء الاصطناعي',
    icon: 'auto_awesome',
    color: 'from-purple-500 to-pink-500',
    extra: ''
  },
  {
    name: 'موقع جيميناي',
    description: 'سوف نستخدمه في توليد الافكار بطرق احترافية',
    icon: 'auto_graph',
    color: 'from-blue-600 to-cyan-400',
    extra: 'سوف تتعلم كتابة اوامر احترافية'
  }
];

export const TRACKS: Track[] = [
  {
    id: 1,
    title: 'مسار التميز الوظيفي والإنتاجية',
    goal: '(Career & Productivity Path)',
    description: 'مصمم للموظفين، الإداريين، والمعلمين الراغبين في إنجاز مهامهم بسرعة واحترافية تخطف الأنظار في بيئة العمل.',
    result: 'كفاءة مهنية استثنائية',
    icon: 'work',
    color: 'primary',
    checklist: [
      'العروض التقديمية التفاعلية (Presentations)',
      'السيرة الذاتية (CV/Resume) وتجاوز أنظمة الفرز (ATS)',
      'التقارير السنوية والشهرية (Infographics)',
      'تنسيق المستندات والخطابات بهوية الشركة',
      'بطاقات العمل (Business Cards) مع رموز QR',
      'جداول العمل والخطط وقوائم المهام (To-Do Lists)',
      'المطبوعات المكتبية والبروشورات التعريفية',
      'السبورة البيضاء (Whiteboards) للعصف الذهني',
      'شهادات الشكر والتقدير احترافية'
    ]
  },
  {
    id: 2,
    title: 'مسار الدخل والمشاريع التجارية',
    goal: '(Income & Freelance Path)',
    description: 'مصمم لمن يبحث عن الاستقلال المالي، سواء بتقديم خدمات التصميم أو بيع المنتجات الرقمية.',
    result: 'استقلال مالي وبزنس متكامل',
    icon: 'payments',
    color: 'secondary',
    checklist: [
      'تصميم وبيع القوالب القابلة لإعادة البيع',
      'المفكرات والكتب الإلكترونية (E-books & Planners)',
      'تصميمات الطباعة عند الطلب (POD)',
      'خدمات إدارة السوشيال ميديا (Carousel, Stories)',
      'تصميم الشعارات والهوية البصرية البسيطة',
      'الدعوات والمناسبات الإلكترونية أو المطبوعة',
      'أوراق العمل التعليمية الجاهزة للبيع',
      'قوائم الطعام (Menus) العصرية والجذابة',
      'إعلانات المنتجات لزيادة المبيعات',
      'ملفات الإنجاز (Portfolio) لإغلاق الصفقات'
    ]
  },
  {
    id: 3,
    title: 'مسار العلامة الشخصية وصناعة المحتوى',
    goal: '(Personal Branding Path)',
    description: 'مصمم للمؤثرين، المدربين، ورواد الأعمال الذين يريدون بناء جمهور قوي وحضور بصري لا يُنسى.',
    result: 'حضور رقمي مؤثر وقوي',
    icon: 'stars',
    color: 'green-500',
    checklist: [
      'هوية حسابات التواصل الموحدة (Instagram Grid)',
      'تصميم الـ (Thumbnails) لزيادة المشاهدات',
      'صناعة ومونتاج الـ (Reels & TikToks)',
      'القصص التفاعلية (Stories) لزيادة التفاعل',
      'البوستات التعليمية المتسلسلة (Carousels)',
      'أغلفة الحسابات (Banners) لمنصات التواصل',
      'قوالب الإقتباسات والمقولات الملهمة',
      'تعديل الصور الشخصية وإزالة الخلفيات',
      'الإعلانات الشخصية للدورات والورش والخدمات',
      'الموقع الإلكتروني المصغر (Bio Link)'
    ]
  }
];

export const TIMELINE: TimelineStep[] = [
  {
    id: 1,
    week: "الأسبوع الأول",
    detail: "2 ورش عمل (بناء القواعد البصرية).",
    icon: "design_services"
  },
  {
    id: 2,
    week: "الأسبوع الثاني",
    detail: "2 ورش عمل (التطبيق على مشاريع حقيقية).",
    icon: "auto_awesome_motion"
  },
  {
    id: 3,
    week: "الأسبوع الثالث",
    detail: "2 ورش عمل (استراتيجيات الدخل والإطلاق).",
    icon: "rocket_launch"
  }
];

export const FAQS = [
  {
    question: "هل سأتعلم التصميم عن طريق كانفا فقط ؟",
    answer: "سوف تتعلم التصميم باستخدام كانفا مع استخدام ادوات الذكاء الاصطناعي بحيث ترفع مستواك الى مستوى اخر!"
  },
  {
    question: "هل سوف اتعلم باستخدام الجوال التصميم ؟",
    answer: "تستطيع ان تتطبق جميع دروس الدورة الفردية باستخدام الجوال ولكن نفضل <strong class='font-black text-gray-900 dark:text-white'>ان يكون لديك لابتوب</strong> او حتى ايباد لتحقيق سلاسة في الشرح."
  },
  {
    question: "هل أحتاج لخبرة سابقة في التصميم? ",
    answer: "لا نهائياً. البرنامج مصمم ليأخذك من الصفر أو من مستوى الهواية إلى الاحتراف التجاري."
  },
  {
    question: "ما الفرق بين هذا البرنامج والكورسات المسجلة؟",
    answer: "الفرق هو 'التوجيه المباشر'. في الكورسات أنت تشاهد فقط، هنا نحن نعمل معاً على تصاميمك ونصحح أخطاءك لحظة بلحظة."
  }
];

export const TESTIMONIALS: Testimonial[] = [
  {
    name: "سارة لاين",
    role: "مصممة وباحثة جمال",
    text: "خذيت دورات وايد من قبل، بس اللي صج لقيته مميز عندك إنك ما بخلت علي بالمعلومة.. حشيت مخي حشو بالمعلومات وعطيتني كل شيء بعكس الدورات اللي كانت تعطيني بالقطاره.",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=SarahLine",
    instagram: "https://www.instagram.com/sarah.line.kw/"
  },
  {
    name: "عائشة",
    role: "صاحبة مشروع",
    text: "التدريب الفردي معك جدا افادني في التصميم وكمان في التسويق و شاركتني معلومات إضافية عن التسويق حتفيدني مستقبلا في مشروعي وكمان الشي الجميل لما بلغتني عن تحديثات كانفا الجديدة",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Aisha",
  }
];

export const CHANGELOG = [
  {
    type: 'New',
    title: 'إمكانية عمل صفحة هبوط لك احترافية',
    description: 'أقدم الآن تصميم صفحة هبوط مثل التي تراها الآن بسعر مناسب جداً لأني أستخدم أدوات الذكاء الاصطناعي في عمل المواقع.',
    date: 'يناير 2026'
  },
  {
    type: 'New',
    title: 'زيادة عدد ورش العمل',
    description: 'يمكن الآن للمشتركين الحصول على أكثر من 6 ورش عمل تدريبية حسب حاجتهم ومستوى تقدمهم لضمان أقصى استفادة.',
    date: 'ديسمبر 2024'
  },
  {
    type: 'Upcoming',
    title: 'تحديثات كثيرة قريباً',
    description: 'نعمل حالياً على تطوير مميزات جديدة لنظام المصمم المحترف ستنطلق تباعاً لتعزيز تجربتكم التدريبية.',
    date: 'قريباً'
  }
];

export const LEARNING_POINTS = [
  "6 ورش مباشرة",
  "أكثر من 20 يوم متابعة",
  "عمل نماذج واقعية والإشراف عليها",
  "تقديم ملاحظات وتعديلات",
  "التعرف والاستكشاف في أكثر من 5 مواقع للتصميم",
  "كتابة أوامر احترافية للذكاء الاصطناعي",
  "والكثير من المفاجآت!"
];
